import type { FC } from 'react'

import Badge from '@segment/matcha/components/Badge'
import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

interface ResourceCardProps {
  href: string
  resourceType: string
  heading: string
  description: string
}

const ResourceCard: FC<ResourceCardProps> = ({ href, resourceType, heading, description }) => {
  return (
    <CardBase href={href}>
      <Card.Body>
        <Card.Accessories>
          <Card.AccessoriesRow>
            <Badge variant="outlined">{resourceType}</Badge>
          </Card.AccessoriesRow>
        </Card.Accessories>
        <Card.Copy>
          <Card.Headline tag="h3">{heading}</Card.Headline>
          <Card.Description>{description}</Card.Description>
        </Card.Copy>
        <Card.Action>
          <ButtonText iconEnd={ChevronRightIcon}>Read more</ButtonText>
        </Card.Action>
      </Card.Body>
    </CardBase>
  )
}

export default ResourceCard
